import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import {
  GET_OFFERING_VARIATIONS,
  GET_OFFERING_VARIATIONS_MEMBERHSIP_ID_PATHNAME,
} from "features/OfferingVariations/OfferingVariations.apis";

export const useOfferingMembershipVariations = ({
  offeringUuid,
  membershipUuid,
  enabled,
}) => {
  return useCustomQuery({
    queryKey: [GET_OFFERING_VARIATIONS],
    url: GET_OFFERING_VARIATIONS_MEMBERHSIP_ID_PATHNAME({
      offeringUuid,
      membershipUuid,
    }),
    enabled: !!enabled,
  });
};
